import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import Validator from 'mixins/validator';
import Resetter from 'mixins/resetter';
import ComposeWindow from 'components/ComposeWindow';
import { Button } from 'react-toolbox';
import { updatePhase, addEventToPhase } from 'actionCreators/phase';
import styles from 'styles/input.scss';
import moment from 'moment';

class SetDueTomorrowModal extends Resetter(Validator(React.Component)) {
  handleClose() {
    super.handleClose();
  }

  handleConfirm = () => {
    const { phase } = this.props;
    const tomorrow = moment().add(1, 'days').hour(8);
    const dueAt = tomorrow.toISOString();
    const mmddyyyy = tomorrow.format('MM/DD/YYYY');
    this.props.addEventToPhase(phase.id, {
      name: 'Due Date Updated',
      kind: 'note',
      data: { note: `Due date set to tomorrow (${mmddyyyy}) via quick action.` },
    }).then(() => { this.handleClose(); });
    this.props.updatePhase({ id: phase.id, due_at: dueAt }, { actionType: 'update_due_at' });
  };

  render = () => (<ComposeWindow active={this.props.active} title="Set Due Date to Tomorrow" onClose={this.handleClose}>
    <div className={styles.row} style={{ marginBottom: 20 }}>
      Are you sure you want to set the phase due date to tomorrow?
    </div>
    <div className={styles.row} style={{ display: 'flex', justifyContent: 'center', gap: '16px' }}>
      <Button label="No" flat ripple onClick={this.handleClose} />
      <Button label="Yes" primary flat ripple onClick={this.handleConfirm} />
    </div>
  </ComposeWindow>);
}

SetDueTomorrowModal.propTypes = {
  active: PropTypes.bool.isRequired,
  phase: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  updatePhase: PropTypes.func.isRequired,
  addEventToPhase: PropTypes.func.isRequired,
};

export default connect(null, { updatePhase, addEventToPhase })(SetDueTomorrowModal);



// WEBPACK FOOTER //
// ./client/app/screens/main/screens/phases/phaseShow/components/setDueTomorrowModal.jsx